/**
 * Video Tab: tabs, background video, and data-fancybox popup link.
 */
import './style.scss';

document.addEventListener('DOMContentLoaded', initVideoTabs);

function initVideoTabs() {
	document.querySelectorAll('.video-tab').forEach((block) => {
		const videoEl = block.querySelector('.video-tab__video--bg');
		const navBtns = block.querySelectorAll('.video-tab__nav-btn');
		const popupLink = block.querySelector('.video-tab__play-overlay');

		if (videoEl) {
			initBgVideo(videoEl);
		}

		navBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				navBtns.forEach((b) => {
					b.classList.remove('is-active');
					b.setAttribute('aria-selected', 'false');
				});
				btn.classList.add('is-active');
				btn.setAttribute('aria-selected', 'true');

				// Update background video container with this tab's data and re-init
				const type = btn.getAttribute('data-video-type');
				const id = btn.getAttribute('data-video-id');
				const url = btn.getAttribute('data-video-url');
				const mp4 = btn.getAttribute('data-mp4');
				const webm = btn.getAttribute('data-webm');

				videoEl.setAttribute('data-video-type', type || '');
				videoEl.setAttribute('data-video-id', id || '');
				videoEl.setAttribute('data-video-url', url || '');
				videoEl.setAttribute('data-mp4', mp4 || '');
				videoEl.setAttribute('data-webm', webm || '');
				videoEl.innerHTML = '';

				if (
					type &&
					(type === 'youtube'
						? id
						: type === 'vimeo'
							? id
							: mp4 || webm)
				) {
					initBgVideo(videoEl);
				}

				// Update Fancybox play overlay href so it opens the current tab's video
				const playOverlay = block.querySelector(
					'.video-tab__play-overlay'
				);
				const linkToUpdate = playOverlay || popupLink;
				if (linkToUpdate) {
					let href = '';
					if (type === 'youtube' && id) {
						href = `https://www.youtube.com/watch?v=${id}`;
					} else if (type === 'vimeo' && id) {
						href = `https://vimeo.com/${id}`;
					} else if (mp4 || webm) {
						href = mp4 || webm;
					}
					linkToUpdate.href = href;
				}
			});
		});
	});
}

function initBgVideo(container) {
	const type = container.getAttribute('data-video-type');
	const id = container.getAttribute('data-video-id');
	const mp4 = container.getAttribute('data-mp4');
	const webm = container.getAttribute('data-webm');

	if (type === 'youtube' && id) {
		initYouTubeBg(container, id);
	} else if (type === 'vimeo' && id) {
		initVimeoBg(container, id);
	} else if (type === 'html5' && (mp4 || webm)) {
		initHtml5Bg(container, mp4, webm);
	}
}

function initYouTubeBg(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		autoplay: '1',
		mute: '1',
		loop: '1',
		playlist: videoId,
		controls: '0',
		rel: '0',
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://www.youtube.com/embed/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute(
		'allow',
		'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
	);
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'video-tab__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initVimeoBg(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		background: 1,
		autoplay: 1,
		muted: 1,
		loop: 1,
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://player.vimeo.com/video/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('allow', 'autoplay; fullscreen');
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'video-tab__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initHtml5Bg(container, mp4, webm) {
	container.style.opacity = '0';
	const video = document.createElement('video');
	video.setAttribute('playsinline', '');
	video.setAttribute('muted', '');
	video.setAttribute('autoplay', '');
	video.setAttribute('loop', '');
	video.className = 'video-tab__video-html5';
	if (webm) {
		const s = document.createElement('source');
		s.src = webm;
		s.type = 'video/webm';
		video.appendChild(s);
	}
	if (mp4) {
		const s = document.createElement('source');
		s.src = mp4;
		s.type = 'video/mp4';
		video.appendChild(s);
	}
	video.addEventListener(
		'canplay',
		() => {
			container.style.opacity = '1';
		},
		{ once: true }
	);
	container.appendChild(video);
	video.play().catch(() => {});
}
